export default __webpack_public_path__ + "static/media/ImageDescription.a8bb75d8.png";